import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { type SupportZendeskTicketModel } from "@doitintl/cmp-models";
import { Chip, Link, Stack, Tooltip } from "@mui/material";

import { useCustomerId } from "../../../../Components/hooks/useCustomerId";
import { getStatusColor } from "../../../../Support/Components/TicketsFilterTable/TicketsTableColumns";
import { transformStatus } from "../../../../utils/common";
import useSegmentTrackEvent from "../../../../utils/useSegmentTrackEvent";

export const TicketRow = ({
  zendeskTicket,
  isLastItem,
}: {
  zendeskTicket: SupportZendeskTicketModel;
  isLastItem: boolean;
}) => {
  const customerId = useCustomerId();
  const history = useHistory();
  const { t } = useTranslation("services");
  const { trackEvent } = useSegmentTrackEvent();

  const { id, status, subject } = zendeskTicket.ticket;

  const handleTicketClick = () => {
    // Track the "Recent Expert Inquiry" event
    trackEvent("Recent Expert Inquiry", {
      source: "Home Dashboard",
      feature: "Home Dashboard",
      target_internal_destination_description: "Recent expert inquiry request navigation",
      ticketId: id,
      ticketStatus: status,
    });

    history.push(`/customers/${customerId}/support/tickets/${id}`);
  };

  return (
    <Tooltip title={subject}>
      <Stack
        direction="row"
        spacing={1}
        flex={1}
        alignSelf="flex-start"
        sx={{
          borderBottom: isLastItem ? "none" : "1px solid",
          borderColor: "divider",
          width: "100%",
          cursor: "pointer",
        }}
        alignItems="center"
        justifyContent="space-between"
        onClick={handleTicketClick}
      >
        <Link color="inherit" underline="always" variant="body2" noWrap sx={{ maxWidth: "80%" }}>
          {subject}
        </Link>
        <Chip variant="status" color={getStatusColor(status)} label={transformStatus(status, t)} />
      </Stack>
    </Tooltip>
  );
};
